import MojitoCore from 'mojito/core';
import SuspendedSelectionLabelImpl from './suspended-selection-label.js';
import PropTypes from 'prop-types';

const { UIView } = MojitoCore.Presentation;

/**
 * Component to display the suspended/expired label on a bet.
 *
 * @class SuspendedSelectionLabel
 * @memberof Mojito.Modules.BetslipView.BetComponents
 */

/**
 * SuspendedSelectionLabel prop types.
 *
 * @property {boolean} [expired = false] - Flag indicating whether the bet is expired.
 *
 * @memberof Mojito.Modules.BetslipView.BetComponents.SuspendedSelectionLabel
 */
const propTypes = {
    expired: PropTypes.bool,
};

const defaultProps = {
    expired: false,
};

export default UIView(
    'SuspendedSelectionLabel',
    SuspendedSelectionLabelImpl,
    propTypes,
    defaultProps
);
